"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GridFilterModule = void 0;
const tslib_1 = require("tslib");
const AdaptableModuleBase_1 = require("./AdaptableModuleBase");
const ModuleConstants = tslib_1.__importStar(require("../Utilities/Constants/ModuleConstants"));
const EditCurrentQueryButton_1 = require("../View/NamedQuery/EditCurrentQueryButton");
const GridFilterStatusbar_1 = require("../View/GridFilter/GridFilterStatusbar");
const StringExtensions_1 = tslib_1.__importDefault(require("../Utilities/Extensions/StringExtensions"));
class GridFilterModule extends AdaptableModuleBase_1.AdaptableModuleBase {
    constructor(api) {
        super(ModuleConstants.GridFilterModuleId, ModuleConstants.GridFilterFriendlyName, 'filter-list', 'GridFilterPopup', 'Controls the Grid Filter funtionality', api);
    }
    updateOldConfig() {
        var _a, _b;
        const oldQueryState = this.api.internalApi.getAdaptableState().Query;
        // - move query to current layout
        const expression = oldQueryState.CurrentQuery;
        if (expression &&
            StringExtensions_1.default.IsNullOrEmpty(this.api.gridFilterApi.getCurrentGridFilterExpression())) {
            this.api.gridFilterApi.setGridFilterExpression(expression);
        }
        // - move dashboard/toolbar
        let updateTabs = false;
        const tabs = this.api.dashboardApi.getTabs().map((tab) => {
            if (tab.Toolbars.includes('Query')) {
                updateTabs = true;
                return Object.assign(Object.assign({}, tab), { 
                    // replace with 'GridFilter'
                    Toolbars: tab.Toolbars.map((t) => (t == 'Query' ? 'GridFilter' : t)) });
            }
            return tab;
        });
        if (updateTabs) {
            this.api.dashboardApi.setTabs(tabs);
        }
        // - move pinned toolbars
        let updatePinnedToolbars = false;
        const pinnedToolbars = (_b = (_a = this.api.dashboardApi.getPinnedToolbars()) === null || _a === void 0 ? void 0 : _a.map) === null || _b === void 0 ? void 0 : _b.call(_a, (pinnedToolbar) => {
            if (pinnedToolbar == 'Query') {
                updatePinnedToolbars = true;
                return 'GridFilter';
            }
            return pinnedToolbar;
        });
        if (updatePinnedToolbars) {
            this.api.dashboardApi.setPinnedToolbars(pinnedToolbars);
        }
    }
    getViewProperties() {
        return {
            getStatusBarPanelProps: () => {
                const popover = this.api.gridFilterApi.getCurrentGridFilterExpression();
                return {
                    content: GridFilterStatusbar_1.GridFilterStatusbar,
                    extraActions: [EditCurrentQueryButton_1.EditGridFilterButton],
                    popover,
                };
            },
        };
    }
}
exports.GridFilterModule = GridFilterModule;
